import { render, staticRenderFns } from "./CommittingOfferList.vue?vue&type=template&id=fa48b6b4&scoped=true&"
import script from "./CommittingOfferList.vue?vue&type=script&lang=js&"
export * from "./CommittingOfferList.vue?vue&type=script&lang=js&"
import style0 from "./CommittingOfferList.vue?vue&type=style&index=0&id=fa48b6b4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa48b6b4",
  null
  
)

export default component.exports